import React from 'react';
import Head from 'next/head';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';

import Layout from '../components/layout';

type Props = {
  currentRoute: string;
};

class PrivacyPolicy extends React.Component<Props> {
  public render() {
    return (
      <Layout {...this.props}>
        <div style={{ width: '100%' }}>
          <Head>
            <title>Privacy Policy</title>
            <meta
              name="description"
              content="Privacy Policy for workinbiotech.com, a job board for all biotech startups."
            />
            <meta name="robots" content="index, follow" />
          </Head>

          <Box sx={{ padding: { xs: '0px 10%', md: '0px 25%' }, marginBottom: '200px' }}>
            <Grid container direction="row" justifyContent="space-around" alignItems="flex-start">
              <Grid item sm={12} xs={12}>
                <p />
                <br />
                <h1
                  style={{
                    lineHeight: '40px',
                  }}
                >
                  Privacy Policy (website and browser extension)
                </h1>
                <hr style={{ width: '100%', margin: '40px auto 0px auto' }} />
              </Grid>
              <Grid item xs={12}>
                <p>
                  Welcome to Work in Biotech (“Service”, “Product”), owned and operated by Work in
                  Biotech LLC (“Company”, “we”, “our”, “us”). This Privacy Policy explains what data
                  we collect from you and why; how this data is handled; and your rights to your
                  data.
                </p>
                <br />
                <h1 style={{ lineHeight: '40px' }}>Summary</h1>
                <p>
                  <li>
                    Work in Biotech is a directory for job postings and career/job pages at biotech
                    startups.
                  </li>
                  <li>
                    We list job postings and career/job pages from various biotech companies across
                    the United States.
                  </li>
                  <li>
                    Work in Biotech also offers a Chrome extension - called AI-cruiter - that
                    generates summaries of resumes for job applicants in various applicant tracking
                    system (ATS) softwares.
                  </li>
                  <li>
                    To use the AI-cruiter Chrome extension, you need to sign up with your email
                    address. We do not collect any other information about you.
                  </li>
                  <li>
                    We collect anonymous data about usage of our website using{' '}
                    <a href="https://plausible.io/" target="_blank" rel="noopener noreferrer">
                      plausible.io
                    </a>
                  </li>
                  <li>
                    We do not use cookies, we do not collect any personal identifiable information
                    about you, and we do not sell such information to third parties.
                  </li>
                  <li>
                    If you violate our Terms, we can block your access to our Service at any time.
                  </li>
                  <li>If you violate our Terms, we can terminate your account at any time.</li>
                  <li>
                    If you have any questions, you can contact us at recruit@workinbiotech.com
                  </li>
                </p>
                <br />
                <h1 style={{ lineHeight: '40px' }}>Third party links</h1>
                <p>
                  Our website includes a large number of third party links. These third party sites
                  have separate and independent privacy policies. We have no responsibility or
                  liability for the content and activities of these linked sites. Nonetheless, we
                  seek to protect the integrity of our site and welcome any feedback about broken
                  links, hijacked websites, etc.
                </p>
                <br />
                <h1 style={{ lineHeight: '40px' }}>Information we collect</h1>
                <p>
                  We collect anonymous data about usage of our website. This may include, but is not
                  limited to, the number of views on a particular page of our website, the number of
                  clicks on particular buttons of our website, the overall traffic to our website,
                  the location(s) and website(s) from which the traffic to our website comes. None
                  of this data contains personal identifiable information about you.
                </p>
                <p>
                  When you email us or fill out one of our contact forms, we receive your contact
                  information and potentially other information that you provide about yourself.
                </p>
                <p>
                  For users of our AI-cruiter Chrome extension, we collect your email address in
                  order to create an account. We do not collect any further information about you.
                </p>
                <p>
                  When you use the AI-cruiter Chrome extension, we save the summaries of job
                  applicant resumes and summaries of job descriptions that you generate. This does
                  not contain personal information about you, and all resume summaries and job
                  description summaries that are more than 6 months old are automatically deleted.
                </p>
                <p>
                  When you make a payment for the AI-cruiter Chrome extension, you enter your card
                  information via a portal managed by{' '}
                  <a href="https://stripe.com/" rel="noopener noreferrer" target="blank">
                    Stripe
                  </a>
                  . Thus, you may be subject Stripe’s personal information collection practices.
                  Please review Stripe’s terms privacy policy.
                </p>
                <br />
                <h1 style={{ lineHeight: '40px' }}>How we use the information we collect</h1>
                <p>
                  We analyze the anonymous usage data for our website and may share such anonymous
                  data publicly on our website and or to third parties who may be interested in
                  sponsoring job postings or advertising on our website.
                </p>
                <p>
                  We may respond to any requests or questions that you send to us via email or one
                  of our contact forms.
                </p>
                <br />
                <h1 style={{ lineHeight: '40px' }}>We do not</h1>
                <p>
                  <li>use cookies. </li>
                  <li>collect any personal identifiable information about you.</li>
                  <li>
                    sell, disclose, or otherwise share any of your personal information to third
                    parties.
                  </li>
                </p>
                <br />
                <h1 style={{ lineHeight: '40px' }}>Changes to Privacy Policy</h1>
                <p>
                  We may revise this Privacy Policy at any time by posting the revised Privacy
                  Policy on this site. Your continued use of Async after the posting of revised
                  Privacy Policy means that you accept and agree to the changes. It is your
                  responsibility to review this Privacy Policy periodically.
                </p>
                <br />
                <h1 style={{ lineHeight: '40px' }}>Contacting us</h1>
                <p>
                  Please send your feedback, comments, questions, or requests for technical support
                  via email to recruit@workinbiotech.com.
                </p>
                <p>
                  Kelly Burke, Work in Biotech LLC <br />
                  recruit@workinbiotech.com <br />
                  401 RYLAND ST STE 200-A, RENO, NV 89502 <br />
                </p>
              </Grid>
            </Grid>
          </Box>
        </div>
      </Layout>
    );
  }
}

export default PrivacyPolicy;
